var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-qrcode-image",
        size: "sm",
        hideHeader: "",
        okOnly: "",
        noFade: ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c("div", { staticClass: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    on: {
                      click: function($event) {
                        return _vm.print()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-print" }),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("button.print")) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    on: {
                      click: function($event) {
                        return ok()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("button.close")) + "\n      "
                    )
                  ]
                )
              ])
            ]
          }
        }
      ])
    },
    [
      _vm.qrcode
        ? _c(
            "div",
            {
              staticClass:
                "template text-center d-flex flex-column align-items-center justify-content-center"
            },
            [
              _c("div", [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("apps.pos.message.tablenumber", {
                        ref_name: _vm.refName,
                        number: _vm.qrcode.tableNumber
                      })
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.qrcode.queueNumber
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("apps.pos.message.queuenumber", {
                            number: _vm.qrcode.queueNumber
                          })
                        )
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "mt-2 qrcode",
                attrs: { src: _vm.qrcode.qrCodeImageUrl }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2 d-flex flex-column" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("apps.pos.message.scantoorder")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("apps.pos.message.scantoorderdetail")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2 d-flex flex-column powered-by" }, [
                _c("hr"),
                _vm._v(" "),
                _c("span", { staticClass: "text-sm" }, [
                  _vm._v("Powered by TreeSoft.io")
                ])
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-053e32e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053e32e3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseBModalQRCodeImage.vue
// module id = null
// module chunks = 